import { formatPrice } from 'utils/helpers/functions/formatPrice';
import { withLocalCurrency, withPrimaryCurrency } from 'utils/helpers/currency/currencyHelpers';

export const formatIncomePrimary = (value: number, rate: number): string =>
    withPrimaryCurrency(formatPrice(value), rate);

export const formatIncomeLocal = (value: number): string => withLocalCurrency(formatPrice(value));
